import React from 'react';
import styles from './style.module.css';
import StepOneForm from '../../components/forms/step-one';

export default () => (
    <div className={styles.page}>
        <h1 className={styles.mainTitle}>What’s your household annual income?</h1>
        <StepOneForm />
    </div>
);
